<template>
  <div>
    <div class="box" v-if="customer">
      <card-section-switch
        :switchItems="switchItems"
        :selected="'Grafik'"
        @cardChanged="handleCardChange"
      />
      <template v-if="selectedCard === 'Grafik'">
        <customer-schedule
          :customerId="customer.id"
          @editOrder="openEditOrder"
          :updateHandle="updateHandle"
        />
        <assigning-employee-to-customer
          :customerId="customer.id"
          :orderToEdit="orderToEdit"
          @updated="ordersUpdated"
        />
      </template>
      <template v-if="selectedCard === 'Zadania'">
        <customer-tasks :customerId="customer.id" />
      </template>
      <template v-if="selectedCard === 'Odpłatność'">
        <customer-payments :customerId="customer.id" />
      </template>
      <template v-if="selectedCard === 'Załączniki/umowa'">
        <customer-attachments :customer="customer" />
      </template>
    </div>
    <div v-else class="box"></div>
  </div>
</template>

<script>
import AssigningEmployeeToCustomer from "./AssigningEmployeeToCustomer.vue";
import CardSectionSwitch from "./CardSectionSwitch.vue";
import CustomerAttachments from "./CustomerAttachments.vue";
import CustomerPayments from "./CustomerPayments.vue";
import CustomerSchedule from "./CustomerSchedule.vue";
import CustomerTasks from "./CustomerTasks.vue";
export default {
  components: {
    CardSectionSwitch,
    CustomerSchedule,
    AssigningEmployeeToCustomer,
    CustomerTasks,
    CustomerPayments,
    CustomerAttachments,
  },
  mounted() {
    this.$store.dispatch("getDodTasksCategories");
    this.$store.dispatch("getDodTasksPriorities");
    this.$store.dispatch("getDodUsers", {
      search: "",
    });
    this.$store.dispatch("getDodAdmins");
    this.$store.dispatch("getDodEmployeesPrimaryInfo");
  },
  name: "CustomerManagement",
  props: ["customer"],
  data: () => {
    return {
      switchItems: ["Grafik", "Zadania", "Odpłatność", "Załączniki/umowa"],
      selectedCard: "Grafik",
      orderToEdit: null,
      updateHandle: 0,
    };
  },
  methods: {
    handleCardChange(card) {
      this.selectedCard = card;
    },
    async openEditOrder(order) {
      this.orderToEdit = order;
    },
    async ordersUpdated() {
      this.updateHandle = new Date().getTime();
    },
  },
};
</script>

<style scoped>
.box {
  padding: 1rem 0 0 0;
  border-radius: 8px;
  border: 0.5px solid rgba(9, 7, 65, 0.25);
  background: #fff;
  box-shadow: 0px 4px 15px 0px rgba(96, 108, 128, 0.25);
}
</style>